<section class="w-full">

  <app-banner_section-type01 [options]="{ title: '', imageHref:view.imageHref }"></app-banner_section-type01>

  <div>
    <!-- Header (Title/Tagline) section -->
    <!-- <div class="mb-8 flex flex-col items-center justify-center text-center">
          <h4 class="text-base text-primry-600 font-semibold tracking-wide uppercase">Our Promotional Section</h4>
          <p class="mt-2 text-5xl lg:text-7xl font-light font-primary tracking-wide text-gray-900 dark:text-gray-200">
            The Travel Experts
          </p>
        </div> -->
    @if(view.site?.id === 80) {
    <div class="mb-8 flex flex-col items-center justify-center text-center">
      <p class="mt-2 py-5 text-5xl lg:text-7xl font-light font-primary tracking-wide text-gray-900 dark:text-gray-200">
        Our Directors and Family
      </p>
    </div>
    }
    @if (view.site?.id === 119) {
    <div class="mb-8 flex flex-col items-center justify-center text-center">
      <p
        class="mt-2 pt-10 max-w-3xl text-xl lg:text-2xl font-light font-primary tracking-wide custom-font text-gray-900 dark:text-gray-200">
        At The Travel Department our team of specialists is devoted to providing exceptional travel services that cater
        to the diverse needs of our corporate and leisure travelers.
      </p>
    </div>
    }
  </div>

  <section class="w-full flex justify-center bg-gray-100 px-6 mb-15">
    @if(view.site?.id === 80) {
    <div class="mt-10 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl">
      <div class="bg-white shadow-lg rounded-lg overflow-hidden" *ngFor="let member of teamMembersNM">
        <img [src]="member.img" alt="{{ member.name }}" class="w-full h-72 object-cover">
        <div class="p-6">
          <h3 class="text-xl font-semibold text-gray-800">{{ member.name }} {{ member.lastName }}</h3>
          <p class="text-gray-600 mt-2">
            {{ member.about }}
          </p>
        </div>
      </div>
    </div>
    }
    @if(view.site?.id === 119) {
    <div class="mt-10 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl">
      <div class="bg-white shadow-lg rounded-lg overflow-hidden flex flex-col" *ngFor="let member of teamMembersTTD">

        <img [src]="member.img" alt="{{ member.name }}" class="w-full h-72 object-cover object-top">

        <div class="flex flex-col flex-grow p-6">
          <h3 class="text-xl tracking-wide font-bold mb-2 text-gray-800">
            {{ member.name }} {{ member.lastName }}
          </h3>
          <p class="italic text-gray-600 font-semibold">{{ member.title }}</p>
          <p class="text-gray-600 text-md mt-2 flex-grow">
            {{ member.about }}
          </p>

          <!-- Button wrapper -->
          <div class="mt-6 flex justify-center">
            <button (click)="sendEmail(member.email)"
              class="px-4 py-2 bg-accent-500 text-white rounded-lg hover:bg-primary-100 cursor-pointer hover:text-primary-500 transition-all duration-300">
              Email me
            </button>
          </div>
        </div>
      </div>
    </div>
    }
    @if(view.site?.id === 154) {
    <div class="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
      <div class="bg-white shadow-lg rounded-lg p-6" *ngFor="let member of teamMembersPT">
        <h3 class="text-xl tracking-wider font-semibold text-gray-800">{{ member.name }} {{ member.lastName }}</h3>
        <p class="text-primary-500 text-md italic mt-2">
          {{ member.title }}
        </p>
        <p class="text-gray-600 mt-2">
          {{ member.about }}
        </p>
      </div>
    </div>
    }
    @if(view.site?.id === 74 || view.site?.id === 96) {
    <div class="flex flex-col">
      <div class="mt-10 max-w-6xl text-center">
        <h2 class="text-3xl lg:text-4xl font-semibold tracking-wide text-gray-900">
          Meet Our Travel Team
        </h2>
        <p class="mt-3 text-lg text-gray-600">
          A dedicated group of specialists ready to plan unforgettable journeys.
        </p>
      </div>
      <div class="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl">
        <div class="bg-white shadow-lg rounded-lg overflow-hidden flex flex-col" *ngFor="let member of teamMembersOVT">

          <img [src]="member.img" alt="{{ member.name }}" class="w-full aspect-[4/5] object-cover object-center">

          <div class="flex flex-col flex-grow p-6">
            <h3 class="text-xl tracking-wide font-bold mb-2 text-gray-800">
              {{ member.name }} {{ member.lastName }}
            </h3>
            <p class="italic text-gray-600 font-semibold">{{ member.title }}</p>
            <p class="text-gray-600 text-lg mt-2 flex-grow">
              {{ expandedMemberId === member.id ? member.about : (member.about | slice:0:220) }}
              <span *ngIf="expandedMemberId !== member.id && member.about?.length > 220">...</span>
            </p>
            <div class="mt-4" *ngIf="member.about?.length > 220">
              <button type="button"
                class="text-primary-600 font-semibold hover:text-primary-500 transition-colors duration-300"
                (click)="toggleMember(member.id)">
                {{ expandedMemberId === member.id ? 'View less' : 'View more' }}
              </button>
            </div>
            <div>
              <p class="mt-2 text-accent-500 italic font-semibold">Contact me: {{member.contact}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-12 flex justify-center">
        <a href="mailto:info@optimavibe.co.za" class="inline-flex items-center justify-center
             px-8 py-3 rounded-md
             text-base font-semibold
             text-white bg-primary-800
             transition-all duration-300 ease-out
             hover:bg-primary-900
             hover:-translate-y-[1px]
             hover:shadow-lg
             focus:outline-none focus:ring-2 focus:ring-primary-700 focus:ring-offset-2">
          Get in Touch
        </a>
      </div>
    </div>
    }
  </section>
</section>